import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authdApiRequest } from '../utils/api';
import Layout from '../components/Layout';
import { toast } from 'react-toastify';

const TRIAGE_LEVELS = [
  { value: 0, label: 'Not Set' },
  { value: 1, label: 'Keep Monitoring' },
  { value: 2, label: 'Make Improvements' },
  { value: 3, label: 'Needs Support' }
];

function TriageStatus() {
  const { snapshotId } = useParams();
  const navigate = useNavigate();
  const [triageResults, setTriageResults] = useState([]);

  useEffect(() => {
    const fetchTriageResults = async () => {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${snapshotId}/triage-results`);
        const data = await response.json();
        setTriageResults(data);
      } catch (error) {
        console.error('Error fetching triage results:', error);
        toast.error('Failed to load triage results');
      }
    };

    fetchTriageResults();
  }, [snapshotId]);

  return (
    <Layout>
            <div className="text-center mb-4">
        <button
          onClick={() => navigate(`/snapshots/${snapshotId}/results`)}
          className="text-sky-500 hover:underline"
        >
          Back to Snapshot
        </button>
      </div>
      <h1 className="text-2xl font-bold mb-8 text-center">
        Triage Results for All Teams
      </h1>
      <table className="w-full bg-neutral-900 rounded-lg text-sm border border-neutral-700">
        <thead>
          <tr>
            <th className="text-left py-2 px-4 border-b-2 border-neutral-700">Topic</th>
            {triageResults.length > 0 && triageResults[0].teams.map(team => (
              <th key={team.teamId} className="text-center py-2 px-4 border-b-2 border-neutral-700">{team.teamName}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {triageResults.map(topic => (
            <tr key={topic.topicId}>
              <td className="border-b border-neutral-700 py-2 px-4 font-bold">{topic.topicName}</td>
              {topic.teams.map(team => {
                const teamCount = topic.teams.length;
                const teamColumnWidth = 70 / teamCount; // Calculate width for each team column
                const status = team.status;
                const backgroundColor = status === 1 ? 'bg-green-500/50' :
                                        status === 2 ? 'bg-yellow-500/50' :
                                        status === 3 ? 'bg-red-500/50' : '';

                return (
                  <td
                    key={team.teamId}
                    className={`border-b border-neutral-700 py-2 px-4 text-center ${backgroundColor}`}
                    style={{ width: `${teamColumnWidth}%` }} // Apply calculated width
                  >
                    {TRIAGE_LEVELS.find(level => level.value === status)?.label || 'Not Set'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </Layout>
  );
}

export default TriageStatus;